export enum CreateWorkTabsEnum {
    STEP1 = "STEP1",
    STEP2 = "STEP2",
}
